module.exports = __webpack_public_path__ + "img/sofa(light).d55a72c.png";